/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import ReduxUtils from '../../utils/ReduxUtils';
import { LIBRARY_ROOT } from '../../utils/Constants';
import RESOURCE_NAMES from '../../api/resources';
var featureName = 'Signup';
/**
 * Indicates whether the user name field will be shown or not.
 */

var SIGNUP_SET_SHOW_USERNAME_FIELD = ReduxUtils.generateActionType(LIBRARY_ROOT, featureName, 'SIGNUP_SHOW_USERNAME_FIELD');
/**
 * Specifies the user input in sign up form.
 */

var SIGNUP_USER_INPUT = ReduxUtils.generateActionType(LIBRARY_ROOT, featureName, 'SIGNUP_USER_INPUT');
/**
 * Sets any signup validation error messages.
 */

var SIGNUP_VALIDATION_ERRORS = ReduxUtils.generateActionType(LIBRARY_ROOT, featureName, 'SIGNUP_VALIDATION_ERRORS');
var SIGNUP_CREATE_TEMP_USER_ACTION_TYPES = ReduxUtils.generatePostActionTypes(LIBRARY_ROOT, RESOURCE_NAMES.generatedUserAccount);
var SIGNUP_POST_ACTION_TYPES = ReduxUtils.generatePostActionTypes(LIBRARY_ROOT, RESOURCE_NAMES.userAccount);
export { SIGNUP_SET_SHOW_USERNAME_FIELD, SIGNUP_USER_INPUT, SIGNUP_VALIDATION_ERRORS, SIGNUP_CREATE_TEMP_USER_ACTION_TYPES, SIGNUP_POST_ACTION_TYPES };